/* ============
 * Embed Component
 * ============
 *
 * todo: add documentation here!
 */

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      previewMessage: this.message,
      previewSubject: this.subject,
      previewEmailTo: this.to,
      previewEmailCC: this.cc,
    };
  },
  computed: {
    ...mapGetters({
      modalButtonLoading: 'modalButtonLoading',
    }),
  },

  mounted() {
    //
  },

  methods: {
    optionFilter(filterValue, allOptions) {
      if (filterValue != '') {
        if (this.validateEmail(filterValue)) jQuery('.ccEmail').removeClass('hidden');
        else jQuery('.ccEmail').addClass('hidden');
      } else {
        jQuery('.ccEmail').removeClass('hidden');
      }
    },

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    sendReminder() {
      const data = {
        message: this.previewMessage,
        subject: this.previewSubject,
        to: this.previewEmailTo,
        cc: this.previewEmailCC,
      };
      this.buttons[1].action(data);
    },
  },

  props: {

    /**
     * The message
     */
    message: {
      type: String,
      required: true,
    },

    /**
     * The subject
     */
    subject: {
      type: String,
      required: true,
    },

    to: {
      type: Array,
      required: false,
    },

    cc: {
      type: Array,
      required: false,
    },

    buttons: {
      type: Array,
      required: false,
    },

  },

  watch: {
    //
  },
};



// WEBPACK FOOTER //
// ./src/app/components/previewMessageReminder/previewMessageReminder.js